<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
        <div class="modal-header">
                <div class="title">
                    <h2 class="modal-title-prefix"><span>UKUPNO - ANALIZA</span></h2>
                </div>
            </div>
            <div class="modal-body">

            <yt-number-input-v3
        name="txtT01StanjeArtiklaZaPeriod" formControlName="T01StanjeArtiklaZaPeriod"
        [Label]="'KARTICAMPARTIKLA.T01STANJEARTIKLAZAPERIOD.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT02ProdajnaCenaArtiklaNaKrajuPeriod" formControlName="T02ProdajnaCenaArtiklaNaKrajuPeriod"
        [Label]="'KARTICAMPARTIKLA.T02PRODAJNACENAARTIKLANAKRAJUPERIOD.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda" formControlName="T03ProdajnaCenaBezPdvArtiklaNaKrajuPerioda"
        [Label]="'KARTICAMPARTIKLA.T03PRODAJNACENABEZPDVARTIKLANAKRAJUPERIODA.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT04VrednostLageraArtiklaNaKrajuPerioda" formControlName="T04VrednostLageraArtiklaNaKrajuPerioda"
        [Label]="'KARTICAMPARTIKLA.T04VREDNOSTLAGERAARTIKLANAKRAJUPERIODA.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT05VrednostLageraBezPdvArtiklaNaKrajuPerioda" formControlName="T05VrednostLageraBezPdvArtiklaNaKrajuPerioda"
        [Label]="'KARTICAMPARTIKLA.T05VREDNOSTLAGERABEZPDVARTIKLANAKRAJUPERIODA.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT06VrednostUlazaArtiklaPoNabavnojCeni" formControlName="T06VrednostUlazaArtiklaPoNabavnojCeni"
        [Label]="'KARTICAMPARTIKLA.T06VREDNOSTULAZAARTIKLAPONABAVNOJCENI.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni" formControlName="T07VrednostIzlazaArtiklaPoProsecnojNabavnojCeni"
        [Label]="'KARTICAMPARTIKLA.T07VREDNOSTIZLAZAARTIKLAPOPROSECNOJNABAVNOJCENI.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT08VrednostIzlazaArtiklaPoProdajnojCeni" formControlName="T08VrednostIzlazaArtiklaPoProdajnojCeni"
        [Label]="'KARTICAMPARTIKLA.T08VREDNOSTIZLAZAARTIKLAPOPRODAJNOJCENI.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT09UkupnoPdvIzlazRobe" formControlName="T09UkupnoPdvIzlazRobe"
        [Label]="'KARTICAMPARTIKLA.T09UKUPNOPDVIZLAZROBE.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv" formControlName="T10VrednostIzlazaArtiklaPoProdajnojCeniBezPdv"
        [Label]="'KARTICAMPARTIKLA.T10VREDNOSTIZLAZAARTIKLAPOPRODAJNOJCENIBEZPDV.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT11RealizacijaDoUlozenogNovca" formControlName="T11RealizacijaDoUlozenogNovca"
        [Label]="'KARTICAMPARTIKLA.T11REALIZACIJADOULOZENOGNOVCA.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
    <yt-number-input-v3
        name="txtT12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda" formControlName="T12UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda"
        [Label]="'KARTICAMPARTIKLA.T12UKUPNOOSTVARENARAZLIKAUCENINAKRAJUPERIODA.SINGULAR'"
        [disabled]='true'>
    </yt-number-input-v3>
            </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
    </div>
</form>